
// src/reducers/divisions-reducer.js

import { mergeArray, deleteArray, updateArray, sortArray, getArray } from '../helpers/store'
import map from 'lodash/map'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'

import {
  FETCH_DIVISIONS,
  FETCH_DIVISIONS_REQUESTED,
  FETCH_DIVISIONS_COMPLETED,
  FETCH_DIVISIONS_FAILED,
  SET_CURRENT_ID,
  SET_CURRENT_DIVISION,
  UPDATE_DIVISION_GROUP_REQUESTED,
  UPDATE_DIVISION_GROUP_COMPLETED,
  UPDATE_DIVISION_GROUP_FAILED,
  UPDATE_DIVISION_COMPLETED,
  DELETE_DIVISION_REQUESTED,
  DELETE_DIVISION_COMPLETED,
  DELETE_DIVISION_FAILED
} from '../actions/divisions'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  items: undefined,
  currentId: undefined,
  currentDivision: undefined,
  activeDialog: false,
  isMembershipUpdating: false,
  isMembershipUpdateFailed: false,
}

export default function divisionsReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_DIVISIONS_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case FETCH_DIVISIONS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: !state.items ? action.results : map(action.results, (result)=> {
        const division = find(state.items, (item)=> item.division_id == result.division_id)
        if (!division) return result   // new devision
        else if (isEqual(division, result)) return division  // dont update same division
        else return Object.assign({}, division, result)  // devision content change
      }),
    })

  case UPDATE_DIVISION_COMPLETED:
    return Object.assign({}, state, {
      items: mergeArray('division_id', state.items, [action.results]),
    })

  case FETCH_DIVISIONS_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })
  case SET_CURRENT_ID:
    return Object.assign({}, state, {
      currentId: action.currentId,
    })
  case SET_CURRENT_DIVISION:
    return Object.assign({}, state, {
      currentId: action.currentDivision,
    })
  case UPDATE_DIVISION_GROUP_REQUESTED:
  case DELETE_DIVISION_REQUESTED:
    return Object.assign({}, state, {
      isMembershipUpdating: true,
      isMembershipUpdateFailed: false,
    })
  case UPDATE_DIVISION_GROUP_FAILED:
  case DELETE_DIVISION_FAILED:
    return Object.assign({}, state, {
      isMembershipUpdating: false,
      isMembershipUpdateFailed: true,
    })
  case UPDATE_DIVISION_GROUP_COMPLETED:
    return Object.assign({}, state, {
      isMembershipUpdating: false,
      isMembershipUpdateFailed: false,
      items: mergeArray('division_id', state.items, [action.results]),
    })

    case DELETE_DIVISION_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: deleteArray('division_id', state.items, action.results.division_id)
      })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/divisions-reducer.js